import Modal from '@/shared/components/UI/Modal';
import Button from '@/shared/components/UI/Button';

interface MarketingInfoPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const MarketingInfoPolicyModal: React.FC<MarketingInfoPolicyModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className="text-left">
        <h2 className="mb-4 text-lg font-bold text-[#1D1D1D]">
          마켓팅 정보 수신 동의
        </h2>

        <div className="max-h-[50vh] overflow-hidden pr-2">
          <div className="text-xs text-[#1D1D1D]">
            <p className="mb-3">
              이벤트, 혜택, 프로모션 및 기타 마케팅 관련 정보 수신에 동의합니다.
            </p>
            <p>
              본 동의는 귀하가 제공한 이메일 주소로 마케팅 정보를 수신하는 것에
              대한 동의를 포함합니다. 귀하는 언제든지 수신 거부할 수 있습니다.
            </p>
          </div>
        </div>

        <div className="mt-6">
          <Button
            type="button"
            variant="primary"
            size="xs"
            onClick={onClose}
            fullWidth
          >
            Verify
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MarketingInfoPolicyModal;
